<template>
  <div class="bg-w ">

    <div class="pd-20">
      <div class="flex a-center">
        <div>公司名称：</div>
        <div>
          <a-input v-model="params.companyName" placeholder="请输入公司名称" type="text" />
        </div>
        <div class="ml-20">手机：</div>
        <div><a-input v-model="params.mobile" placeholder="请输入手机号码" type="text" /></div>
        <div class="ml-20"><a-button type="primary" @click="search">查 询</a-button> <a-button type="primary" @click="add">新 增</a-button> <a-button @click="reset">清 空</a-button> <a-button :loading="loading" @click="exp">导出Excel</a-button></div>
      </div>
    </div>
    <div class="pd-20">
      <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="addressType" slot-scope="row">
          {{ addressType[row.addressType] }}
        </div>
        <div slot="address" slot-scope="row" class="text-over">
          {{ $utils.formatAddr(row) }}
        </div>
        <div slot="action" slot-scope="row">
          <span class="f-c-blue pointer" @click="edit(row)">编辑</span>
          <span class="ml-10 f-c-blue pointer" @click="del(row)">删除</span>
        </div>
      </a-table>
    </div>
    <AddrEditor :visible.sync="visible" :info="cInfo" @success="editSuccess" />
    <AddrEditor :visible.sync="visible1" :address-type="type" @success="addSuccess" />
  </div>
</template>
<script>
import AddrEditor from '@/components/addrEditor'
const columns = [
  { title: '姓名', dataIndex: 'contactName', key: 'contactName' },
  { title: '寄件/收件', key: 'addressType', scopedSlots: { customRender: 'addressType' }},
  { title: '公司名称', dataIndex: 'companyName', key: 'companyName' },
  { title: '手机', key: 'mobile', dataIndex: 'mobile' },
  { title: '电话', dataIndex: 'phone', key: 'phone' },
  { title: '详细地址', key: 'address', scopedSlots: { customRender: 'address' }},
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]

export default {
  components: {
    AddrEditor
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      visible1: false,
      addressType: {
        1: '寄件',
        2: '收件'
      },
      columns,
      params: {
        'mobile': '',
        'companyName': '',
        addressType: this.type
      },
      list: [],
      loading: false,
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      },
      cInfo: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.pagination.current = 1
      this.getList()
    },
    add() {
      this.visible1 = true
    },
    edit(row) {
      this.cInfo = { ...row }
      this.visible = true
    },
    async del(row) {
      const res = await this.$http({ ...this.$api.addressDelete, origin: true }, {
        id: row.id
      })
      if (res.data.state === 'success') {
        this.$message.success('删除成功')
        this.getList()
      } else {
        this.$message.error(res.data.msg)
      }
    },
    async exp(button) {
      try {
        button.loading = true
        this.params.pageIndex = this.pagination.current
        this.params.pageSize = this.pagination.pageSize
        await this.$down(this.$api.addressExportList, this.params)
        button.loading = false
      } catch (error) {
        button.loading = false
      }
    },
    reset() {
      this.params.mobile = ''
      this.params.companyName = ''
      this.pagination.current = 1
    },
    getKey(row) {
      return row.id
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    editSuccess() {
      this.$message.success('更新地址成功')
      this.visible = false
      this.getList()
    },
    addSuccess() {
      this.$message.success('增加地址成功')
      this.visible1 = false
      this.pagination.current = 1
      this.getList()
    },
    async getList(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.addressGetPageList, this.params)
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
      }
    }
  }
}
</script>
